/* eslint-disable react/prop-types */
import { DataGrid } from 'devextreme-react';
import {
  Button,
  Column,
  Editing,
  FilterRow,
  HeaderFilter,
  Pager,
  Paging,
} from 'devextreme-react/data-grid';
import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { Spinner } from 'reactstrap';
import { gridSubMenuDataSource } from '~/pages/SubMenu/SubMenuServices';
import { Container } from './styles';

function Lista({ loading }) {
  const history = useHistory();
  const [pageIndex, setPageIndex] = useState(null);
  const [pageSize, setPageSize] = useState(10);

  function handleOptionChange(event) {
    if (event.fullName === 'paging.pageSize' && event.value !== pageSize) {
      setPageSize(event.value);
      setPageIndex(0);
    }

    setPageIndex(null);
  }

  const applyFilterTypes = [
    {
      key: 'auto',
      name: 'Immediately',
    },
    {
      key: 'onClick',
      name: 'On Button Click',
    },
  ];

  const filterOptions = {
    showFilterRow: true,
    showHeaderFilter: true,
    currentFilter: applyFilterTypes[0].key,
  };

  return (
    <Container>
      <section>
        <div className="sec1">
          <h1>Sub menus</h1>
        </div>
        <div className="add">
          <Link to="/menu-sub/register" className="link">
            <FaPlus />
          </Link>
        </div>
      </section>

      {loading ? (
        <Spinner
          color="dark"
          style={{ height: '3rem', width: '3rem', margin: '5% 400px' }}
        />
      ) : (
        <DataGrid
          dataSource={gridSubMenuDataSource}
          remoteOperations
          showBorders
          allowColumnReordering
          allowColumnResizing={false}
          columnAutoWidth={false}
          onOptionChanged={handleOptionChange}
        >
          <Editing mode="row" useIcons allowDeleting />
          <Pager
            visible
            showPageSizeSelector
            allowedPageSizes={[7, 10, 15]}
            showInfo
          />
          <Paging defaultPageSize={pageSize} pageIndex={pageIndex} />
          <FilterRow
            visible={filterOptions.showFilterRow}
            applyFilter={filterOptions.currentFilter}
          />
          <Column
            dataField="id"
            caption="ID sub menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="nome"
            caption="Nome Menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="descricao"
            caption="Descricao Menu"
            filterOperations={false}
            alignment="left"
          >
            <HeaderFilter groupInterval={70} />
          </Column>
          <Column
            dataField="tipoPagina"
            caption="Tipo Pagina"
            filterOperations={false}
            allowFiltering={false}
            alignment="left"
            cellRender={(e) =>
              e.row.data.tipoPagina === 'M' ? 'Menu' : 'Opção'
            }
          />
          <Column
            dataField="url"
            caption="Rota"
            filterOperations={false}
            allowFiltering={false}
            alignment="left"
          />
          <Column type="buttons" caption="Ações" width={100}>
            <Button
              hint="Editar"
              visible
              icon="edit"
              onClick={(e) => history.push(`/menu-sub/update/${e.row.data.id}`)}
            />
            <Button name="delete" visible hint="Deletar" icon="trash" />
          </Column>
        </DataGrid>
      )}
    </Container>
  );
}

export default Lista;
